// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

function block(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.display("flex"),
              BsCssJs$PrezzeeRibbon.justifyContent("center"),
              BsCssJs$PrezzeeRibbon.flexDirection("column"),
              BsCssJs$PrezzeeRibbon.backgroundColor(match.emailSignUp.backgroundColor),
              BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius),
              BsCssJs$PrezzeeRibbon.backgroundRepeat("noRepeat"),
              BsCssJs$PrezzeeRibbon.backgroundPosition("right"),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
                    BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(360)),
                    BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(106)),
                    BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(106))
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mediaRange(Theme__Responsive$PrezzeeRibbon.tabletBreakpoint, Theme__Responsive$PrezzeeRibbon.tabletSmBreakpoint), [
                    BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(360)),
                    BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(55)),
                    BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(55))
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [
                    BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(295)),
                    BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(20)),
                    BsCssJs$PrezzeeRibbon.backgroundPosition({
                          NAME: "hv",
                          VAL: [
                            "center",
                            "bottom"
                          ]
                        })
                  ])
            ]);
}

function backgroundImages(desktopImageUrl, tabletImageUrl, mobileImageUrl) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.backgroundImage({
                          NAME: "url",
                          VAL: desktopImageUrl
                        })]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mediaRange(Theme__Responsive$PrezzeeRibbon.tabletBreakpoint, Theme__Responsive$PrezzeeRibbon.tabletSmBreakpoint), [BsCssJs$PrezzeeRibbon.backgroundImage({
                          NAME: "url",
                          VAL: tabletImageUrl
                        })]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [BsCssJs$PrezzeeRibbon.backgroundImage({
                          NAME: "url",
                          VAL: mobileImageUrl
                        })])
            ]);
}

var Styles = {
  block: block,
  backgroundImages: backgroundImages
};

function EmailSignUp(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    block(theme),
                    className$1
                  ])
            });
}

var Heading;

var BodyText;

var CtaLine;

var Success;

var make = EmailSignUp;

export {
  Styles ,
  Heading ,
  BodyText ,
  CtaLine ,
  Success ,
  make ,
}
/* classnames Not a pure module */
